import React from 'react';
import { Box, Typography, Paper, Divider } from '@mui/material';
import { Helmet } from 'react-helmet';

function LostItemInRailwayStation() {
  return (
    <Paper sx={{ p: { xs: 2, md: 4 } }}>
      <Helmet>
        <title>రైల్వే స్టేషన్‌లో వస్తువు పోతే ఏం చేయాలి? | Lost & Found Guide</title>
        <meta
          name="description"
          content="రైల్వే స్టేషన్ లేదా రైలు ప్రయాణంలో వస్తువు పోయినప్పుడు తీసుకోవాల్సిన చర్యలు. RPF, GRP, 139 హెల్ప్‌లైన్, మరియు మా వెబ్‌సైట్‌లో పోస్ట్ చేయడం గురించి పూర్తి సమాచారం."
        />
        <meta
          name="keywords"
          content="రైల్వే స్టేషన్, వస్తువు పోయింది, lost item railway station, RPF, GRP, 139 helpline"
        />
        <link rel="canonical" href="https://find.skyrool.com/lost-item-in-railway-station" />
      </Helmet>

      <Typography variant="h3" component="h1" gutterBottom>
        రైల్వే స్టేషన్‌లో వస్తువు పోతే ఏం చేయాలి?
      </Typography>
      <Typography variant="subtitle1" color="text.secondary" sx={{ mb: 2 }}>
        ప్రచురించబడినది: ఆగస్టు 14, 2025
      </Typography>
      <Divider sx={{ mb: 3 }} />

      <Typography variant="body1" paragraph>
        రైలు ప్రయాణంలో లేదా రైల్వే స్టేషన్‌లో వస్తువులు పోవడం చాలా సాధారణం. ప్రతిరోజూ వేలాది మంది ప్రయాణికులు తమ వస్తువులను మర్చిపోతుంటారు. ఒకవేళ మీ వస్తువు పోతే, కంగారు పడకుండా ఈ క్రింది చర్యలు తీసుకోండి.
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>దశ 1: వెంటనే సమీపంలోని అధికారులను సంప్రదించండి</Typography>
      <Typography variant="body1" paragraph>
        మీరు రైల్వే స్టేషన్‌లో ఉంటే, వెంటనే స్టేషన్ మాస్టర్, రైల్వే ప్రొటెక్షన్ ఫోర్స్ (RPF), లేదా గవర్నమెంట్ రైల్వే పోలీస్ (GRP) అధికారులను సంప్రదించండి. వారికి మీ సమస్యను వివరంగా చెప్పండి.
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>దశ 2: రైల్వే హెల్ప్‌లైన్‌కు కాల్ చేయండి</Typography>
      <Typography variant="body1" paragraph>
        భారతీయ రైల్వే హెల్ప్‌లైన్ నంబర్ <strong>139</strong> కు కాల్ చేసి, మీ ఫిర్యాదును నమోదు చేయండి. వారు మీకు ఒక ఫిర్యాదు నంబర్‌ను ఇస్తారు, దానిని భద్రంగా ఉంచుకోండి.
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>దశ 3: మా వెబ్‌సైట్‌లో పోస్ట్ చేయండి</Typography>
      <Typography variant="body1" paragraph>
        పైన చెప్పిన చర్యలతో పాటు, మీ పోయిన వస్తువు గురించి మా వెబ్‌సైట్‌లో ఒక <strong>"Lost Item"</strong> పోస్ట్ పెట్టడం చాలా ముఖ్యం. మీ వస్తువు యొక్క ఫోటో, పోయిన ప్రదేశం, మరియు ఇతర వివరాలను స్పష్టంగా నమోదు చేయండి. ఒకవేళ ఎవరైనా మంచి వ్యక్తికి అది దొరికితే, వారు మీ పోస్ట్‌ను చూసి, మిమ్మల్ని ఇన్-యాప్ చాట్ ద్వారా సంప్రదించే అవకాశం ఉంది.
      </Typography>

      <Typography variant="h5" sx={{ mt: 4, mb: 2 }}>దశ 4: సోషల్ మీడియాలో షేర్ చేయండి</Typography>
      <Typography variant="body1" paragraph>
        మీరు మా వెబ్‌సైట్‌లో పోస్ట్ చేసిన తర్వాత, ఆ పోస్ట్ యొక్క వివరాలను WhatsApp, Facebook వంటి సోషల్ మీడియా ప్లాట్‌ఫారమ్‌లలో షేర్ చేయండి. దీనివల్ల, సమాచారం వేగంగా ఎక్కువ మందికి చేరుతుంది.
      </Typography>
    </Paper>
  );
}

export default LostItemInRailwayStation;
